<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Users" :path="breadcrumbPath" />

    <!-- <ActionBar @actionClick="actionClick" /> -->

    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                            </template>
                            <el-option
                              v-for="(item, index) in search_by_dropdown['selectedTableTab']"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="new-add-user-btn new-button-behavior x-end"
                      size="small"
                    >
                      <svg class="width-125 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#addNewUserButton"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_user"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>

    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
    />
  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { convertToTitleCase } from "../dashboard/common/common-tools";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "users",
  components: {
    Breadcrumbs,
    DataTable,
    ShowDetail,
    // ActionBar,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Users",
          disabled: false,
          href: "/users",
          active: true,
        },
      ],

      show: true,
      userDataList: [],
      search: "",

      search_by_dropdown: 
        {
          selectedTableTab: [
            'full_name',
            'email',
            'country',
          ],
        },

      selectedSearchBy: 'full_name',

      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {},
  computed: {
    filter_user() {
      return this.userDataList;
    },
  },
  mounted() {
    this.fetchUserData(this.current_page);
  },
  methods: {
    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },

    changePage(page) {
      this.fetchUserData(page);
    },
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },

    fetchUserData(page) {
      
      UserService.getUsers(this.selectedSearchBy, this.search, page, this.perPageCount )
        .then(
          (response) => {
            this.userDataList = response.data.users;
            this.total_items = response.data.total_record;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    DeleteUser(user, index) {
      UserService.deleteUser(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.userDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.userDataList.length == this.current_row_index)
        this.userDataList.push(event);
      else this.userDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    // handleExportFile() {
    //   if (this.filter_user.length > 0) {
    //     const myHeader = [
    //       "full_name",
    //       "email",
    //       "is_active",
    //       "is_superuser",
    //       "is_staff",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_user, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "UserList.xlsx");
    //   }
    // },
    async handleExportFile() {
      console.log("datalist", this.filter_user);
      
      const dataList = this.filter_user; // Your data
      const skipKeys = ["first_name","last_name","id", "customer_id"]; // Keys to skip
      const fileName = "UserList.xlsx"; // File name
      const newWorksheetName = "User List"; // Worksheet name
      const title = "User List"; // Title for the Excel file

      try {

      
      await exportToExcel({
        dataList,
        skipKeys,
        fileName,
        newWorksheetName,
        title,
      });
    } catch(err) {
      console.log("err when export excel", err.message);
      
    }
    },


    
    handleReload() {
      this.fetchUserData(this.current_page);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        is_active: true,
        customer_id: null,
        is_admin: false,
        is_auditor: false,
        id: 0,
      };
      this.current_row_index = this.userDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    // filterSearch(event) {
    //   this.search = event.search;
    // },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchUserData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    deleteRow(event, index) {
      // console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteUser(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
